export default __webpack_public_path__ + "static/media/qlinnButton.7005222c.png";